import axios, { AxiosResponse } from 'axios';
import { API_URL_CONFIG } from '@/config/urlConfig/apiUrlConfig';
import { axiosInventoryInstance } from '@/config/apiConfig';
import { ALL_LOCATION, ALL_OPERATOR } from '@/constant/global/global.constant';
import { EMarketsData } from '@/constant/market/market.constant';
import _ from 'lodash';
import { IFetchdevice, IDevice } from './device.type';

// Define the Device interface representing the structure of the user object returned by the API

export const fetchDevice = ({
  page,
  limit,
  startDate,
  endDate,
  order,
  orderBy,
  deviceId,
  deviceName,
  marketId,
  inactive,
  operatorId,
  locationId,
  sn,
  type,
  includeInactive,
  deviceIdentifier,
}: IFetchdevice): Promise<AxiosResponse<IDevice[], any>> => {
  return axiosInventoryInstance({
    url: API_URL_CONFIG?.DEVICE?.GET_DEVICE,
    params: {
      page,
      limit,
      deviceId,
      deviceName,
      ...(marketId !== EMarketsData[0].marketId ? { marketId } : {}),
      includeInactive,
      inactive,
      ...(operatorId !== ALL_OPERATOR.id ? { operatorId } : {}),
      ...(locationId !== ALL_LOCATION.locationId ? { locationId } : {}),
      ...(startDate ? { startDate } : {}),
      ...(endDate ? { endDate } : {}),
      ...(order ? { order } : {}),
      ...(orderBy ? { orderBy } : {}),
      ...(deviceIdentifier ? { deviceIdentifier } : {}),
      ...(type ? { type } : {}),
    },
  });
};

export const fetchAllDevicesList = ({
  page = 1,
  limit = 10,
  operatorId = '',
  providerId = '',
  marketId = '',
  orderBy,
  order,
  name,
}: IFetchdevice): Promise<AxiosResponse<IFetchdevice, any>> => {
  let params: any = {
    page,
    limit,
    ...(orderBy ? { orderBy } : {}),
    ...(order ? { order } : {}),
    ...(name ? { name } : {}),
    ...(providerId ? { providerId } : {}),
    ...(operatorId ? { operatorId } : {}),
    ...(marketId ? { marketId } : {}),
  };

  if (!params.operatorId && !params.marketId && !params.providerId) {
    params = {
      ...params,
      operatorId: 1, // Set operatorId to 1
    };
  }

  return axiosInventoryInstance({
    url: API_URL_CONFIG.DEVICE.GET_DEVICES_LIST,
    params,
  });
};
